/**
 * 裁切比例
 * @type {*[]}
 */
export const cropTypes = [
  { name: "Square", type: 0, ratio: 1 },
  { name: "Landscape", type: 1, ratio: 1.91 },
  { name: "Portrait", type: 2, ratio: 0.8 },
];
/**
 * repeat 自定义中的类型
 * @type {*[]}
 */
export const repeatCustomType = [
  { text: "Daily", key: "daily" },
  { text: "Weekly", key: "weekly" },
  { text: "Monthly", key: "monthly" },
];
